import {DadProductPrice} from './dadProductPrice';

export class DadProduct {
  id: number;
  productCode: string;
  startDate: string;
  productType: string;
  dadProductPrices: DadProductPrice[];

  constructor(productCode: string, productType: string, startDate: any, id: number, dadProductPrices: DadProductPrice[]) {
    this.productCode = productCode;
    this.productType = productType;
    this.startDate = startDate;
    this.id = id;
    this.dadProductPrices = dadProductPrices;
  }
}
